import { useState } from 'react';

import { InternalModule, MAX_COLLAPSED, EXPANDED_HEIGHT } from '../launch.constants';
import {
  Panel, PanelHeader, PanelTitle, PanelSubtitle, PanelFooter, ListContainer,
  SkeletonListItem, SkeletonIcon, SkeletonName, SkeletonDescription,
} from '../styles';
import { ModuleRow, HoverInfo } from './ModuleRow';

const SKELETON_COUNT = 3;

interface ModulesPanelProps {
  modules: InternalModule[];
  height?: number;
  isLoading?: boolean;
  onOpenModule: (path: string) => void;
  onHover?: (info: HoverInfo | null) => void;
}

const ModuleRowSkeleton = () => (
  <SkeletonListItem data-testid="module-row-skeleton">
    <SkeletonIcon />
    <SkeletonName />
    <SkeletonDescription />
  </SkeletonListItem>
);

export const ModulesPanel = ({ modules, height, isLoading = false, onOpenModule, onHover }: ModulesPanelProps) => {
  const [expanded, setExpanded] = useState(false);

  return (
    <Panel
      style={{
        height: expanded ? EXPANDED_HEIGHT : height,
        maxHeight: 'calc(100vh - 220px)',
      }}
    >
      <PanelHeader>
        <PanelTitle>Módulos</PanelTitle>
        <PanelSubtitle>Herramientas internas de Polynator</PanelSubtitle>
      </PanelHeader>

      <ListContainer data-scrollable={expanded ? 'true' : undefined}>
        {isLoading
          ? Array.from({ length: SKELETON_COUNT }, (_, i) => `skeleton-${i}`).map((id) => (
              <ModuleRowSkeleton key={id} />
            ))
          : modules.map((mod) => (
              <ModuleRow key={mod.id} module={mod} onOpen={onOpenModule} onHover={onHover} />
            ))}
      </ListContainer>

      {!isLoading && modules.length > MAX_COLLAPSED && (
        <PanelFooter onClick={() => setExpanded((v) => !v)}>
          {expanded ? 'Ver menos ↑' : `Ver todos (${modules.length}) →`}
        </PanelFooter>
      )}
    </Panel>
  );
};
